import {Link, Box, Typography } from "@mui/material";

//This component is responsible for rendering the self-assessment static text. 
export default function SelfAssessmentStaticText() {
    return (
        <>
            <Typography variant="h6" color="black" component="div">
                <Box sx={{ fontWeight: 'bold' }}>Self-Assessment and Core Competencies</Box>
            </Typography>
            <Typography variant="body1" component="div" sx={{ mt:2, mb:1, width: "60%", minWidth: 255 }}>
                Rate yourself on the following core competencies and milestones. You can access definitions of each level as defined by ACGME <Link variant = "inherit" underline="always" target="blank" rel="noopener" href="https://www.acgme.org/globalassets/pdfs/milestones/pediatricsmilestones.pdf">here</Link>.
            </Typography>
            <Typography variant="body1" component="div" sx={{ mt:1, mb:1, width: "60%", minWidth: 255 }}>
                Medical Students & Fellows in Training - select rating for each competency.
            </Typography>
            <Typography variant="body1" component="div" sx={{ mt:1, mb:2, width: "60%", minWidth: 255 }}>
                Residents - select rating for each milestone.
            </Typography>
        </>
    );
}